// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrap_wrapper__IVVKb","progress":"Wrap_progress__q-hpT","title":"Wrap_title__ZJj8u","wrap":"Wrap_wrap__rxq1j"};